import { useMutation, useQueryClient } from 'react-query';

import {
  createAdditionalCapacity,
  SaveAdditionalCapacityOptions,
  updateAdditionalCapacity
} from 'RestAPIs/scenario-additional-capacity';

import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

import { queryKeys as BorrowAndLendingQueryKeys } from '../../BorrowAndLending/queries';

type UseQueryProps = {
  onSuccess: () => void;
};

export const useSaveAdditionalCapacityQuery = ({
  onSuccess
}: UseQueryProps) => {
  const queryClient = useQueryClient();

  const handleSuccess = async () => {
    await queryClient.invalidateQueries([
      BorrowAndLendingQueryKeys.SCENARIO_FLEX_CAPACITY_SETTINGS
    ]);
    await queryClient.invalidateQueries([
      BorrowAndLendingQueryKeys.ADDITIONAL_CAPACITY
    ]);
    showSuccessSnackbar();
    onSuccess();
  };

  return useMutation(
    (options: SaveAdditionalCapacityOptions) =>
      options.capacityId
        ? updateAdditionalCapacity(options)
        : createAdditionalCapacity(options),
    {
      onSuccess: handleSuccess,
      onError: showErrorSnackbar
    }
  );
};
